export default "__VITE_ASSET__Bbpuk_KQ__"